/* eslint-disable */
import Swiper from 'swiper/bundle';

const pageHome = document.querySelector('body.home');

if(pageHome) {

  var swiper = new Swiper('.swiper-container.swiper-home-banner', {
    pagination: {
      el: '.home-swiper-pagination-wrapper > .inner-wrapper > .home-pag',
    },
    watchOverflow: true,
    navigation: {
      nextEl: '.home-swiper-pagination-wrapper > .inner-wrapper > .home-next',
      prevEl: '.home-swiper-pagination-wrapper > .inner-wrapper > .home-prev',
    },
  });

}




// WEBPACK FOOTER //
// ./scripts/home.js